import GlobalSearch from "./lib/GlobalSearch";

export * from "./lib/GlobalSearch";

export default GlobalSearch;
